import { Button, Modal, TextInput } from "@src/components/elements";
import React, { useState } from "react";
import { v4 } from "uuid";

interface AddTaxPayerIdModalProps {
  onClose: () => void;
  onAdd: (taxPayerId: {
    id: string;
    taxPayerIdentificationNumber: string;
  }) => void;
}

export const AddTaxPayerIdModal: React.FC<AddTaxPayerIdModalProps> = ({
  onClose,
  onAdd,
}) => {
  const [taxPayerId, setTaxPayerId] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (taxPayerId.trim()) {
      onAdd({ id: v4(), taxPayerIdentificationNumber: taxPayerId.trim() });
      setTaxPayerId("");
      onClose();
    }
  };

  return (
    <Modal title="Add EIN/TIN" onClose={onClose}>
      <form onSubmit={handleSubmit} className="column start">
        <TextInput
          name="taxPayerId"
          label="EIN/TIN"
          placeholder="Enter the EIN/TIN"
          value={taxPayerId}
          onChange={(e) => setTaxPayerId(e.target.value)}
        />
        <div className="row end">
          <Button variant="tertiary" onClick={onClose}>
            Cancel
          </Button>
          <Button type="submit" disabled={!taxPayerId.trim()}>
            Add
          </Button>
        </div>
      </form>
    </Modal>
  );
};
